import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46c2707d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeBanner: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/HomeBanner.vue').default,HomeProducts: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/HomeProducts.vue').default,CompanyProfile: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/CompanyProfile.vue').default,FeaturedProducts: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/FeaturedProducts.vue').default,UserFeedback: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/UserFeedback.vue').default,ApplicationArea: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/ApplicationArea.vue').default,NewsSection: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/NewsSection.vue').default,InquiryForm: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/InquiryForm.vue').default})
